import { createRoute } from "@tanstack/react-router";
import { AuthenticatedShell } from "@/layouts/AuthenticatedShell";
import MainLayout from "@/layouts/MainLayout";
import {
  createAccessGuard,
  requireAuthenticated,
  requireWalletSetup,
} from "@/routing/guards";
import type { UserRoleValue, UserTypeValue } from "@/types";
import { rootRoute } from "./__root";

export const authenticatedLayoutRoute = createRoute({
  getParentRoute: () => rootRoute,
  id: "authenticated",
  beforeLoad: async (opts) => {
    const auth = await requireAuthenticated(opts);
    await requireWalletSetup({
      context: opts.context,
      location: opts.location,
      user: auth.user,
    });
    return auth;
  },
  component: AuthenticatedShell,
});

export function createProtectedLayoutRoute(
  id: string,
  roles: UserRoleValue[],
  usertypes: UserTypeValue[],
) {
  return createRoute({
    getParentRoute: () => authenticatedLayoutRoute,
    id,
    beforeLoad: createAccessGuard(roles, usertypes),
    component: MainLayout,
  });
}
